// @flow
import React, { useState } from 'react';
import { Button } from '@finect/tabular-core/Button';
import { X } from '@finect/tabular-icons/x';
import { LeadPillModal } from './LeadPillModal';
import { Bar, BarText, BarClose } from './partials';

/**
 * Versión móvil/tablet (≤ miniDesktop) del CTA de captación de asesor: barra inferior fija
 * y poco invasiva (descartable) que ocupa el hueco donde en desktop va la tarjeta del
 * sidebar `ProfileLeadCTA`. Al pulsar "Solicitar" abre la misma píldora en un modal.
 *
 * Es deliberadamente fina y se puede cerrar para no molestar la lectura, manteniendo a la
 * vez el punto de captación siempre accesible.
 */
export const ProfileLeadBar = () => {
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <Bar>
      <BarText>Encuentra un asesor financiero para tu dinero</BarText>

      <Button
        color="secondary"
        variant="medium"
        width="auto"
        data-fi-event="perfilAsesor-buscarAsesorMovil"
        onClick={() => setOpen(true)}
      >
        Buscar asesor
      </Button>

      <BarClose type="button" aria-label="Cerrar" onClick={() => setDismissed(true)}>
        <X size="20" />
      </BarClose>

      {open ? <LeadPillModal onClose={() => setOpen(false)} /> : null}
    </Bar>
  );
};
